import type { CreateActionRequest } from 'api/__GENERATED';
import { timeUtility } from 'utility';
import { errorWrapper } from 'utility/error';

import { apiClient } from './api';
import { toAction } from './transformers/toAction';

// Sends a create-action request to Action_Create and returns the
// server-assigned Data.Action. improvementAreaId must be non-null — callers
// are expected to guard before calling this function.
// startAt/endAt are DateItem fields on Data.Action, converted to ISO strings
// for the request body using the raw Date constructor.
async function createAction(args: { tenantId: string; action: Data.Action }) {
  const { tenantId, action } = args;

  const body: CreateActionRequest = {
    // Caller is responsible for ensuring improvementAreaId is non-null
    improvementAreaId: action.improvementAreaId!,
    title: action.name,
    problemStatement: action.problemStatement,
    solutionProposal: action.solutionProposal,
    definitionOfDone: action.definitionOfDone,
    status: action.status,
    startAt: timeUtility
      .toDate({ type: 'day', ...action.startAt })
      .toISOString(),
    endAt: timeUtility.toDate({ type: 'day', ...action.endAt }).toISOString(),
    priority: action.priority,
    responsibleEmployee: action.responsibleEmployee,
    suggestionIds: action.suggestionIds,
  };

  const apiCall = apiClient.Action_Create(body, {
    params: { tenantId },
  });

  return await errorWrapper({
    apiCall,
    error: {
      message: '',
      severity: 'warning',
      title: 'Failed to create action',
    },
    onSuccess: (dto) => {
      const createdAction = toAction(dto);
      return { action: createdAction };
    },
  });
}

export { createAction };
